import { render, staticRenderFns } from "./DepartmentGrid.vue?vue&type=template&id=19f6fbf4"
import script from "./DepartmentGrid.vue?vue&type=script&lang=js"
export * from "./DepartmentGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports